import { DECREASE, INCREASE } from "./actionTypes";

const initialState = {
    products: [
        {
            id: 1,
            productName: "Asus Vivobook X515MA",
            quantity: 20,
            price: 35500,
        },
        {
            id: 2,
            productName: "Dell E1916HV 18.5 Inch",
            quantity: 35,
            price: 9300,
        },
        {
            id: 3,
            productName: "Canon Eos 4000D 18MP",
            quantity: 72,
            price: 36500,
        },
    ],
    carts: [],
};

const addToCartReducer = (state = initialState, action) => {
    switch (action.type) {
        case INCREASE:
            const payloadId = action.payload.id;
            const { carts, products } = state;

            // Decrease product quantity by increasing order quantity
            const updatedIncreaseProductQuantity = products.map((product) => {
                if (product.id === payloadId) {
                    return { ...product, quantity: product.quantity - 1 };
                } else {
                    return product;
                }
            });

            //-----Add product and update order quantity in cart----

            //Check whether the product in cart exits or not. If not then add the product in cart.
            if (carts?.find((cart) => cart.id === payloadId) == null) {
                return {
                    ...state,
                    products: updatedIncreaseProductQuantity,
                    carts: [...state.carts, { id: payloadId, quantity: 1 }],
                };
            } else {
                // If the product exits in the cart. Just update it's quantity.
                const updatedQuantity = carts?.map((cart) => {
                    if (cart.id === payloadId) {
                        return { ...cart, quantity: cart.quantity + 1 };
                    } else {
                        return cart;
                    }
                });

                return {
                    ...state,
                    products: updatedIncreaseProductQuantity,
                    carts: updatedQuantity,
                };
            }

        case DECREASE:
            // Increase product quantity by decreasing order quantity
            const updatedDecreaseProductQuantity = state?.products.map(
                (product) => {
                    if (product.id === action?.payload?.id) {
                        return { ...product, quantity: product.quantity + 1 };
                    } else {
                        return product;
                    }
                }
            );

            //Decrease the item quantity.
            const updatedQuantity = state?.carts?.map((cart) => {
                if (cart.id === action.payload.id) {
                    return { ...cart, quantity: cart.quantity - 1 };
                } else {
                    return cart;
                }
            });

            return {
                ...state,
                products: updatedDecreaseProductQuantity,
                carts: updatedQuantity,
            };

        default:
            return state;
    }
};

export default addToCartReducer;
